<div class="card-slider">
  <div class="cards" #scrl (scroll)="scrollCheck()">
    @if (isLoading) {
      @for (item of [].constructor(5); track $index) {
        <p-skeleton
          class="skeleton"
          borderRadius="12px"
          width="100%"
          height="100%" />
      }
    } @else {
      @for (slide of slides; track slide) {
        <app-card
          [card]="slide"
          (cardClicked)="onCardClicked(slide)"></app-card>
      }
    }
    <div (click)="slide(-300)" class="leftArrow cursor-pointer circle-large">
      <div class="circle-icon">
        <i class="fa-regular fa-chevron-left fa-xs"></i>
      </div>
    </div>
    <div (click)="slide(300)" class="rightArrow cursor-pointer circle-large">
      <div class="circle-icon">
        <i class="fa-regular fa-chevron-right fa-xs"></i>
      </div>
    </div>
  </div>
</div>
